import { useContext } from 'react'
import { IntercomContext } from './IntercomContext'

export const useIntercomBoot = () => useContext(IntercomContext)

export default useIntercomBoot
